import { Download } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

type WalletsHeaderProps = {
  userName: string;
  activeCount: number;
};

export const WalletsHeader = ({ userName, activeCount }: WalletsHeaderProps) => {
  const { t } = useTranslations("wallets");
  return (
    <header className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <p className="mb-1 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
          {t("page_eyebrow")}
        </p>
        <h1 className="text-2xl font-semibold leading-tight text-foreground">
          {t("page_title_with_name", { name: userName || t("page_eyebrow") })}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("page_subtitle", { count: activeCount })}</p>
      </div>
      <ColocaButton variant="default" icon={Download} disabled>
        {t("export_balance_button")}
      </ColocaButton>
    </header>
  );
};
